import React from 'react';
import { connect } from 'react-redux';
import { isMobileOnly as isMobile, isTablet } from 'react-device-detect';
import MainHeadlineComponent from './MainHeadlineComponent';
import LobbyTabsHolder from './LobbyTabs/LobbyTabsHolderComponent';
import { clearSelectedAbroadPackage } from './cellcomAbroadBlockSlice';

const CellcomAbroadLobby = (props) => {
  return (
    <>
      <MainHeadlineComponent
        title={
          isMobile || (isTablet && props.data.isPortrait) || props.data.isSmallResolution
            ? props.data.epiStyleInitializationData.mobileTitle
            : props.data.epiStyleInitializationData.desktopTitle
        }
        isSmallResolution={props.data.isSmallResolution}
        isPortrait={props.data.isPortrait}
      />
      <LobbyTabsHolder
        context={props.context}
        linkForAbroadSelfCare={props.iContent.linkForAbroadSelfCare}
        validateCustomerType={props.validateCustomerType}
        validateExistedPackages={props.validateExistedPackages}
        validateExistedPackagesBusinessIndividual={props.validateExistedPackagesBusinessIndividual}
        changeAccountBusinessIndividual={props.changeAccountBusinessIndividual}
        clearSelectedAbroadPackage={props.clearSelectedAbroadPackage}
      />
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    data: state.cellcomAbroad,
  };
};

const mapDispatchToProps = { clearSelectedAbroadPackage };

export default connect(mapStateToProps, mapDispatchToProps)(CellcomAbroadLobby);
